import { Textarea } from '@skytech/ui'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

import { Translation } from '@/app/translations/Translation'

export const NewTerminationConfirm = () => (
  <>
    <h3>
      <Translation id="Confirm" />
    </h3>
    <Field name="comment">
      {({ field }: FieldProps) => (
        <Textarea
          isFullWidth
          id="comment"
          label={<Translation id="Comment" />}
          marginBottom={16}
          {...field}
        />
      )}
    </Field>
  </>
)
